import {
  cityOptions,
  countryOptions,
  pincodeOptions,
  stateOptions,
} from './addressData'
import {
  DEALER_USER,
  DIGITAL_RETAILER,
  FIELD_ENGINEER,
  PRODUCT_MANUFACTURE,
} from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'

const userTranslationKey = {
  admin: 'user_Admin',
  dealer: 'user_Dealer',
  contractor: 'user_Contractor',
  customer: 'user_Customer',
  transporter: 'user_Transporter',
  [PRODUCT_MANUFACTURE]: 'user_ProductManufacturer',
  [DIGITAL_RETAILER]: 'user_DigitalRetailer',
  [DEALER_USER]: 'user_ServiceManager',
  [FIELD_ENGINEER]: 'user_Technician',
}

const userRelationKey = {
  associate: 'ASSOCIATE',
  nonAssociate: 'NON_ASSOCIATE',
  childAssociate: 'CHILD_AND_ASSOCIATE',
}

const associateKey = {
  user_DigitalRetailer: 'user_AssociatedDigitalRetailerList',
  user_Dealer: 'user_AssociatedDealerList',
  user_Contractor: 'user_AssociatedContractor',
  user_ProductManufacturer: 'user_AssociatedProductManufacturerList',
}

const {
  admin,
  productManufacture,
  digitalRetailer,
  dealer,
  customer,
  transporter,
  dealerUser,
  contractor,
  fieldEngineer,
} = userWiseRole

const getReduxKey = {
  [admin]: 'admin',
  [productManufacture]: 'product-manufacture',
  [digitalRetailer]: 'digital-retailer',
  [dealer]: 'dealer',
  [customer]: 'customer',
  [transporter]: 'transporter',
  [dealerUser]: 'dealer-user',
  [contractor]: 'contractor',
  [fieldEngineer]: 'field-engineer',
}

const roleIdByPath = {
  admin,
  dealer,
  customer,
  transporter,
  contractor,
  [PRODUCT_MANUFACTURE]: productManufacture,
  [DIGITAL_RETAILER]: digitalRetailer,
  [DEALER_USER]: dealerUser,
  [FIELD_ENGINEER]: fieldEngineer,
}

const addUserInitial = {
  businessName: '',
  lastName: '',
  pincode: null,
  country: '',
  state: '',
  city: '',
  address: '',
  emailId: '',
  emailId1: '',
  emailId2: '',
  emailId3: '',
  emailId4: '',
  emailId5: '',
  emailId6: '',
  emailId7: '',
  emailId8: '',
  emailId9: '',
  emailId10: '',
  phoneNumber: '',
  departmentName: '',
  inchargeName: '',
}

const addBuildingInitial = {
  name: '',
  pincode: null,
  country: '',
  state: '',
  city: '',
  address: '',
  emailId: '',
  emailId1: '',
  emailId2: '',
  emailId3: '',
  emailId4: '',
  emailId5: '',
  emailId6: '',
  emailId7: '',
  emailId8: '',
  emailId9: '',
  emailId10: '',
  phoneNumber: '',
}

const commonForm = {
  pincode: {
    label: 'user_Pincode',
    validateTrigger: 'onChange',
    inputType: 'select',
    options: pincodeOptions,
    className: 'show-clear-icon',
    allowClear: true,
    md: 24,
    sm: 24,
  },
  country: {
    label: 'txt_Country',
    validateTrigger: 'onChange',
    inputType: 'select',
    disabled: true,
    options: countryOptions,
    md: 24,
    sm: 24,
  },
  multipleRow1: {
    state: {
      label: 'user_State',
      validateTrigger: 'onChange',
      inputType: 'select',
      md: 12,
      sm: 24,
      options: stateOptions,
    },
    city: {
      label: 'user_City',
      validateTrigger: 'onChange',
      inputType: 'select',
      options: cityOptions,
      md: 12,
      sm: 24,
    },
  },
  address: {
    label: 'user_Address',
    validateTrigger: 'onChange',
    inputType: 'textArea',
    md: 24,
    sm: 24,
  },
  emailList: [
    {
      label: 'user_Email',
      validateTrigger: 'onChange',
      inputType: 'input',
      md: 24,
      sm: 24,
    },
  ],
  phoneNumber: {
    label: 'user_Contact',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
}

const addUserForm = {
  businessName: {
    label: 'user_BusinessName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
  lastName: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
  ...commonForm,
  departmentName: {
    label: 'user_DepartmentName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
  inchargeName: {
    label: 'user_InChargeName',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
  username: {
    label: 'auth_UserName',
    validateTrigger: 'onChange',
    inputType: 'input',
    autoComplete: 'off',
    md: 24,
    sm: 24,
  },
  password: {
    label: 'auth_Password',
    validateTrigger: 'onChange',
    inputType: 'password',
    autoComplete: 'new-password',
    md: 24,
    sm: 24,
  },
}
const addBuildingForm = {
  name: {
    label: 'user_Name',
    validateTrigger: 'onChange',
    inputType: 'input',
    md: 24,
    sm: 24,
  },
  ...commonForm,
}
const RATING_LENGTH = 5

export {
  RATING_LENGTH,
  addUserForm,
  addUserInitial,
  getReduxKey,
  roleIdByPath,
  userTranslationKey,
  addBuildingForm,
  addBuildingInitial,
  userRelationKey,
  associateKey,
}
